export default {
  title: 'Relevés mensuels',
  list: {
    empty_list: {
      title: "Aucun relevé mensuel pour l'instant.",
    },
    fields: {
      month: 'Mois',
      stripe_service_invoice_url: 'Facture Stripe',
      paypal_service_invoice_url: 'Facture PayPal',
    },
    button: {
      title: 'Exporter',
    },
  },
  export_modal: {
    title: 'Exporter',
    start_date: {
      title: 'Date de début',
      placeholder: 'date',
    },
    end_date: {
      title: 'Date de fin',
      placeholder: 'date',
    },
    button: {
      export: 'Exporter',
      close: 'Fermer',
    },
  },
  toasts: {
    failed_to_load_data: 'Échec du chargement des données',
  },
};
